var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _vm._l(_vm.placeholders, function(placeholder) {
        return _c(
          "div",
          { staticClass: "campaigneditor-placeholders-missing" },
          [
            _c(
              "form-section",
              { attrs: { header: placeholder.description } },
              [
                _c(
                  "form-input",
                  [
                    _c("campaign-banner-selector", {
                      key: _vm.version,
                      attrs: {
                        id: "banner-filter-input",
                        placeholder: "Type in banner",
                        placeholderId: placeholder.id,
                        banners: _vm.banners[placeholder.id] || [],
                        value: _vm.chosenFormat(placeholder.id)
                      },
                      on: {
                        input: function($event) {
                          return _vm.bannerSelected($event, placeholder)
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.getCanvasContentIndex(placeholder.id) > -1
                  ? _c("campaign-canvas-content-form", {
                      staticClass: "placeholder",
                      on: { updated: _vm.onUpdated },
                      model: {
                        value:
                          _vm.value.canvasContent[
                            _vm.getCanvasContentIndex(placeholder.id)
                          ],
                        callback: function($$v) {
                          _vm.$set(
                            _vm.value.canvasContent,
                            _vm.getCanvasContentIndex(placeholder.id),
                            $$v
                          )
                        },
                        expression:
                          "value.canvasContent[getCanvasContentIndex(placeholder.id)]"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.ChangeBannerDialog
        ? _c("popupDialog", { attrs: { dialogModel: _vm.ChangeBannerDialog } })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }